import {estimateRunningThresholdPace, type RunningPaceInput} from './estimateRunningThresholdPace';
export function readinessThresholds(zones: Record<string, unknown>, runningProfile?: RunningPaceInput & {status?: string; processing?: {ready?: number}; profile?: Array<{observed?: {pace_sec_per_km?: number} | null}>} | null) {
  const positive = (value: unknown) => Number.isFinite(Number(value)) && Number(value) > 0 ? Number(value) : null;
  const power = zones.power_zones as { threshold?: number } | null | undefined;
  const speed = zones.speed_zones as { threshold?: number; pace_seconds_per_km?: number } | null | undefined;
  const hasRunningData = runningProfile?.status === 'ready' && runningProfile.profile?.some(point => positive(point.observed?.pace_sec_per_km) != null) === true;
  return {
    ftp: positive(zones.ftp) ?? positive(power?.threshold),
    lthr: positive(zones.lt_hr),
    // Prefer a running-only observed-effort estimate; keep explicit configured pace as fallback.
    // Never infer pace from an unscoped legacy speed threshold.
    pace: estimateRunningThresholdPace(runningProfile)?.secondsPerKm ?? (hasRunningData ? positive(speed?.pace_seconds_per_km) : null),
  };
}
